import React from "react";
import * as Yup from "yup";
import { REQUIRED_FIELD_MESSAGE } from "../../../../../CONSTANTS";
import { useMutation, useQuery } from "react-query";
import { resetPassword, getOperator, editOperators } from "../../../../../api/operator/operatorApi";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import UserForm from "../UserForm";
import { useNavigate, useParams } from 'react-router-dom'
import Spinner from 'react-bootstrap/Spinner';

// Form Field validations
const userValidationSchema = Yup.object().shape({
    mobile: Yup.string().min(9,"mobile must be at least 11 characters").max(10,"mobile must be at least 11 characters").required(REQUIRED_FIELD_MESSAGE),
    usernameC: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    f_name: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    l_name: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    email: Yup.string().email().required(REQUIRED_FIELD_MESSAGE),
    //role: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    group: Yup.string().required(REQUIRED_FIELD_MESSAGE),
  });

// Form Labels
const labels = { sendBtnLabel: "ارسال" };

/* Main Component */
function EditUser() {

    /* use Navigate -> For Navigate to User list */
    const navigate = useNavigate();
    
    //Get Params From URL
    const {userId} = useParams();

    // React Query -> use For Edit Operator Api 
    const mutation = useMutation((operator: any) => editOperators(operator));

    /* Image States And functions */
    // Image State
    const [showImages, setShowImages] = React.useState<boolean>(false);
    //Image Close and Open show functions
    const closeShowImagesModal = () => setShowImages(false);
    const openShowImagesModal = () => setShowImages(true);

    /* use Query -> Get User By ID */
    const { data, isLoading, isError, error } = useQuery(
        ["operators", userId],
        () => getOperator({ id:userId }),
      );
    

    // Form initial values
    const initialValues = {
        mobile: data?.mobile,
        usernameC: data?.username,
        passwordC: data?.password,
        confirmPassword: data?.confirmPassword,
        f_name: data?.f_name,
        l_name: data?.l_name,
        nationalCode: data?.nationalCode,
        personalCode: data?.personalCode,
        email: data?.email,
        role: data?.role?.id.toString() ?? data?.role,
        group: data?.group,
        imageId: data?.image?.imageId,
        imageName: data?.image?.imageName,
        activation: data?.activation || 1,
    };
    //Formik library -> config for create operator
    const formik = useFormik({
        initialValues :  initialValues ,
        validationSchema: userValidationSchema,
        enableReinitialize:true,//when this item is true, by change initialValue in component , formik values changed 
        onSubmit: async (values) => {
            const {
                mobile,
                usernameC,
                passwordC,
                confirmPassword,
                f_name,
                l_name,
                personalCode,
                nationalCode,
                email,
                role,
                group,
                activation,
            } = values;
    
            const operator = {
                id:userId,
                mobile : mobile.toString(),
                username:usernameC,
                // password:passwordC,
                // confirmPassword,
                f_name,
                l_name,
                personalCode: personalCode.toString(),
                nationalCode: nationalCode.toString(),
                email,
                Role : role,
                group,
                image: values.imageId?values.imageId :null,
                activation: activation || 1,
            };
     mutation.mutate(operator)
        },
        });


    /* Api Response Messages */
    // Message -> Error
    if (mutation.isError&&formik.isValid) {
        toast.error("اشکال در ارسال", { position: "top-center",toastId:1 });
    }
    
    // Message -> Success
    if (mutation.isSuccess) {
        toast.success("اطلاعات کارشناس با موفقیت ویرایش شد", { position: "top-center" });
        //formik.resetForm();
        mutation.reset();
        navigate('/operator/users')

    }

    //For get operator
    if(isError){
        return  <div>اشکال در ارتباط!</div>
    }

    if(isLoading) {
        return  <Spinner animation="grow" />
    }


    
    return(
        <div className={""}>
            <div className={"card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between bg-white" +
                " pt-5"}>
                <h2>ویرایش</h2>
            </div>

            {/* If data get from server correctly -> user form component show */}
            {data && data !== undefined &&
                <UserForm
                    formik={formik}
                    openShowImagesModal={openShowImagesModal}
                    labels={labels}
                    userId={userId}
                    editable
                />
            }
            {/* Image Selector Modal */}
            {/*<ImagesModal*/}
            {/*    handleHide={closeShowImagesModal}*/}
            {/*    show={showImages}*/}
            {/*    formik={formik}*/}
            {/*/>*/}
        </div>
    )
}

export default EditUser
